import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const PostDetails = () => {
  const { id } = useParams();

  useEffect(() => {
    // This component handles deep links for posts
    // For Universal Links (iOS) and App Links (Android), the OS intercepts
    // the link BEFORE it reaches the web server if the app is installed.
    // If we reach here on mobile, it means:
    // 1. The app is not installed, OR
    // 2. The deep link configuration isn't working properly
    
    const userAgent = navigator.userAgent || navigator.vendor;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    if (isAndroid || isIOS) {
      // On mobile devices, if the app is installed, the OS should have
      // intercepted the link already. If we're here, prompt to install the app.
      // Redirect to app store after a brief delay to show the message
      const redirectTimer = setTimeout(() => {
        if (isAndroid) {
          window.location.replace(
            'https://play.google.com/store/apps/details?id=com.gotoecomapp'
          );
        } else if (isIOS) {
          window.location.replace(
            'https://apps.apple.com/in/app/gotoecom/id6743615043'
          );
        }
      }, 2000);

      return () => clearTimeout(redirectTimer);
    }
  }, [id]);

  return (
    <main style={{ textAlign: 'center', padding: '2rem' }}>
      <h2>Post {id}</h2>
      <p>This post should open in the GoToEcom app.</p>
      <p>If you're on a mobile device and the app is installed, it should have opened automatically.</p>
      <p>If not, you'll be redirected to download the app...</p>
    </main>
  );
};

export default PostDetails;
